<template>
 <div>
   <joint-project-index
       :table-columns="columns"
       :api="api"
       :share-platform="sharePlatName"
       :join-project-title="['多样性','代谢组']"
       table-col-key="bz_metabo_col2"
       @addProject="addBzMetaboProject"
       :projectInfo="projectInfo"
      >
     <template slot="sampleNames" slot-scope="{text,record}">
       <sample-group-detail :right-groups="record.metSampleName" :left-groups="record.ampSampleName" :title="['多样性','代谢组']"></sample-group-detail>
     </template>
   </joint-project-index>
 </div>

</template>

<script>

import {jointProjectColumns} from "@/utils/data/tableCol/projectTableCol";
import JointProjectIndex from "@/components/project/jointProject/JointProjectIndex.vue";
import {
  addBzMetaboProject,
  bzMetaboProjectChangeUser,
  bzMetaboProjectCustomerRemarkEdit,
  bzMetaboProjectDel,
  bzMetaboProjectPage,
  bzMetaboProjectRemarkEdit
} from "@/api/bzMetabo";
import SampleGroupDetail from "@/components/project/transMetabo/SampleGroupDetail.vue";
import {addTransMetaboProject, transMetaboProjectPage} from "@/api/transMetabo";
import {projectList} from "@/api/project";

export default {
  components: {SampleGroupDetail, JointProjectIndex},
  data() {
    return {
      platName:'bzMetabo',
      sharePlatName:'BZ_METABO',
      api:{
        getList:  bzMetaboProjectPage,
        del: bzMetaboProjectDel,
        editRemark:bzMetaboProjectRemarkEdit,
        editCustomerRemark: bzMetaboProjectCustomerRemarkEdit,
        changeUser: bzMetaboProjectChangeUser
      },
      projectInfo: {
        leftRightInfo: {
          titles:{
            left: '多样性',
            right: '代谢组'
          },
          platNames:{
            left: 'bz',
            right: 'metabo'
          },
          exampleProjectIds:{
            left: 'bzAnalysisXXXXXXXXXXXXXX',
            right: 'metaboProjectXXXXXXXXXXXXXX'
          },
          webUrls:{
            left: 'projectBz',
            right: 'projectMetabo'
          }
        }
      },
      isHasProject: false,
    };
  },
  computed: {
    columns() {
      let role = this.$store.getters["right/getRole"]
      let column
      column = jointProjectColumns(this.searchConditionTag || []).filter(item => !item.model||item.model.includes(this.platName))
      if (['ANALYST', 'TECH'].includes(this.$store.getters["right/getRole"])) {
        column.splice(column.length - 1, 1)
      }
      return column
    }
  },
  async mounted() {
    this.role = this.$store.getters["right/getRole"]
    await this.getData(true)
    if (this.role === 'USER'&&!this.isHasProject) {
      let flagInfo = await this.getBzMetaboAllProject()
      const pro = [flagInfo.bzNum, flagInfo.metaboNum].map(num => num === 0)
      const [noTrans, noMetabo] = pro
      if (!flagInfo.flag) {
        let confirmText = `<span >必须同时有多样性和代谢组项目才能使用联合分析功能！</span>`
        let tip = ''
        if (noTrans && noMetabo) {
          tip = `<span>您当前暂无多样性和代谢组项目！</span>`
        } else if (noTrans) {
          tip = `<span >您当前暂无多样性项目!</span>`
        } else if (noMetabo) {
          tip = `<span >您当前暂无代谢组项目!</span>`
        }
        if (tip) confirmText = confirmText + tip
        this.$confirmUi(confirmText, '温馨提示', {
          confirmButtonText: '前往代谢组交付系统',
          cancelButtonText: '前往多样性交付系统',
          dangerouslyUseHTMLString: true,
          type: 'error',
          showCancelButton: noMetabo,
          showConfirmButton: noTrans,
          closeOnClickModal: false,
          showClose: false,
          confirmButtonClass: 'el-button--primary',
          cancelButtonClass: 'el-button--success',
          customClass: 'no-confirm'
        }).then(() => {
          this.$router.push({path: '/projectMetabo'})
        }).catch(() => {
          this.$router.push({path: '/projectBz'})
        })
      }
    }

  },
  methods: {
    async addBzMetaboProject(sendData, callback) {
      const data = {
        ampProjectId: sendData.leftProjectId,
        metProjectId: sendData.rightProjectId,
        customerRemark: sendData.customerRemark,
        remark: sendData.remark,
      }
      try {
        const res = await addBzMetaboProject(data)
        callback(res?.code === 200)
      } catch (err) {
        // 接口报错直接回传false
        callback(false)
      }
    },
    async getBzMetaboAllProject() {
      const [bzRes, metaboRes] = await Promise.all([
        projectList({}, 'bz'),
        projectList({}, 'metabo')
      ]);
      if (bzRes?.code === 200 && metaboRes?.code === 200) {
        return {
          flag: bzRes.data.totalNum > 0 && metaboRes.data.totalNum > 0,
          bzNum: bzRes.data.totalNum,
          metaboNum: metaboRes.data.totalNum
        }
      }
      return {
        flag: false,
        bzNum: 0,
        metaboNum: 0
      }
    },
    async getData() {
      const res = await bzMetaboProjectPage({},{})
      if(res?.code===200){
        this.isHasProject = Number(res.data.total) > 0
      }
    },
  }
};
</script>
